// extracted by mini-css-extract-plugin
module.exports = {"className":"dv-MV_className__Rpr_A"};